import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/useAuth";

export default function CuentaGuard() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="container" style={{ padding: "4rem 0" }}>
        <p className="mono">Verificando sesion...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate to="/login" replace state={{ desde: location.pathname }} />
    );
  }

  return <Outlet />;
}
